import { RecountedForm } from "app/component/form/recounted/RecountedForm";

export const RecountedPage = RecountedForm;
